import {
  GetArticleQuery_query_article_Article_events_ArticleEvent_category_Category,
  GetArticleQuery_query_article_Article_events_ArticleEvent,
} from '../../../../__generated__/queries-web';

export type GetArticleEvent = Omit<
  GetArticleQuery_query_article_Article_events_ArticleEvent_category_Category,
  '__typename'
> & {
  order: number;
};
export const getArticleEvent = ({
  order,
  id,
  title,
}: GetArticleEvent): GetArticleQuery_query_article_Article_events_ArticleEvent => ({
  __typename: 'ArticleEvent',
  order,
  category: {
    __typename: 'Category',
    id,
    title,
  },
});
